import { getCO2AequivalentSubscope5 } from '../getCO2Aequivalent';
import { getCO2Scope3StructureVorgelagert } from '../../../bereiche/dateneingabe/functions/getCO2Scope3Structure';
import { getDatenqualitaet } from '../getDatenqualitaet';
import { getSystemparameter } from '../getSystemparameter';
import { IDs } from '../../../helpers/IDs';
import { Kennzahl } from '../strukturiert/Kennzahl';
import { makeSimpleKennzahl } from '../strukturiert/makeKennzahl';
import { setKennzahlObj } from '../strukturiert/KennzahlTools';
import { setKennzahlS3Co2Gesamt } from '../processKennzahlenBerechnungCO2Scope3';

export function processSubscope5(row: any, data: any, item: any, jahr: number) {
    row = { ...row };
    const konfData: any[] = data[IDs.ENT_KONFIGURATION] || [];
    const co2_fussabdruck_ghg = konfData.length > 0 && konfData[0].co2_fussabdruck_modus === 'ghg';
    const modus = row.modus;
    const key_wert = 'co2_fussabdruck_s3_ss5_wert';
    const key_items = 'co2_fussabdruck_s3_ss5_items';
    let value = 0;
    const faktor = getCO2AequivalentSubscope5(data, jahr, row);
    if (!modus || modus === '0' || !co2_fussabdruck_ghg || modus === 'waste_specific') {
        value = faktor.wert * (row.menge / 1000);
        if (row.kategorie === 'gemischt') {
            const volumen_tonne = row.volumen_tonne;
            const leerungen = row.leerungen;
            const liter_jahr = (volumen_tonne) * leerungen;
            const factor_waste = getSystemparameter(data, 'process_subscope5_waste_factor');
            // const t_jahr = (liter_jahr / 1000) / (factor_waste > 0 ? factor_waste : 10);
            const t_jahr = liter_jahr / 1000;
            value = faktor.wert * t_jahr;
            row.menge = liter_jahr;
            row.einheit = 'Liter';
        } else {
            row.einheit = 'kg';
        }
        row.faktor_einheit = 'gCO₂Äq/' + row.einheit;
        row.value = value;
        row.name = faktor.name;
        row.quelle = faktor.quelle;
        row.faktor = faktor.wert * 1000;
        row.datenqualitaet_emissionsfaktor = faktor.datenqualitaet;
    } else if (modus === 'supplier_specific') {
        value = +row.co2_absolut / 1000;
        row.value = value;
        row.name = faktor.name;
        row.quelle = 'Eingabe durch Nutzer:in';
        row.menge = row.co2_absolut;
        row.faktor = '';
        row.faktor_einheit = '(absoluter Wert)';
        row.einheit = 'kgCO₂Äq';
    } else if (modus === 'user_specific') {
        row.name = row.name_nutzer;
        row.menge = row.menge_nutzer;
        row.einheit = row.einheit_nutzer;
        row.value = row.menge_nutzer && row.faktor_nutzer ? row.faktor_nutzer * row.menge_nutzer : row.menge_nutzer;
        row.faktor = row.faktor_nutzer ? row.faktor_nutzer * 1000000 : null;
        row.faktor_einheit = `gCO₂Äq/${row.einheit_nutzer || ''}`;
        row.quelle = `Eingabe durch Nutzer:in${row.quelle_nutzer ? ` / Quelle: ${row.quelle_nutzer}` : ''}`;
    }

    if (row.kategorie === 'weitere' && !row.name) {
        row.name = row.freie_eingabe;
    }

    if (!item[key_items]) {
        item[key_items] = [];
    }
    item[key_items].push(row);
    item[key_wert] = (item[key_wert] || 0) + (row.value || 0);
    item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + (row.value || 0);
    item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (row.value || 0);

     // Kennzahl erstellen
     makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss5_' + row.tid, jahr, row.standort_tid_orig, row.tid,
     'Menge' , row.name, row.menge, row.value, row.einheit,
     row.faktor, row.quelle, data, row.faktor_einheit);
}

export function processAbwasserSubscope5(data: any, item: any, jahr: number, standort: any) {
    const key_wert = 'co2_fussabdruck_s3_ss5_wert';
    const key_items = 'co2_fussabdruck_s3_ss5_items';

    if (!item[key_items]) {
        item[key_items] = [];
    }
    // console.log('SS1_WASSER:', row);
    const modul: string = (data || {}).MODUL_SELECTED || null;

    // const menge = item.wasser_verbrauch_jahr + (+item.regen_brunnennutzung || 0); // item.wasser_verbrauch_jahr;
    const menge = modul === 'cfm'
        ? item.abwasser
        : item.wasser_verbrauch_jahr + (+item.regen_brunnennutzung || 0); // item.wasser_verbrauch_jahr;

    if (!menge) {
        return;
    }
    const faktor = getCO2AequivalentSubscope5(data, jahr, { kategorie: 'abwasser' });
    // console.log('Abwasser: ', modul , faktor, item);
    const value = faktor.wert * (menge);
    const row_wasser: any = {};
    row_wasser.value = value;
    row_wasser.name = faktor.name;
    row_wasser.quelle = faktor.quelle;
    row_wasser.menge = menge;
    row_wasser.einheit = 'm³';
    row_wasser.faktor_einheit = 'gCO₂Äq/m³';
    row_wasser.faktor = faktor.wert * 1000000;
    row_wasser.datenqualitaet = getDatenqualitaet(item.abwasser_datenqualitaet || []);
    row_wasser.tid = 'wasser';
    // console.log('Wasser', row_wasser, item);
    item[key_items].push(row_wasser);
    item[key_wert] = (item[key_wert] || 0) + value;
    item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + (value || 0);
    item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (value || 0);
    // console.log('SS5 AW - OUT: ', jahr, value, item.co2_fussabdruck_scope3, item.co2_fussabdruck_total);
    const rowCopy = { ...row_wasser, jahr };
    const structure: any = (getCO2Scope3StructureVorgelagert() || []).find((subscopes: any) => subscopes.subscope === 5) || {};
    const kennKey = `s3_${structure.key}_${rowCopy.tid}`;
    const standort_tid = (standort || {}).tid;
    setKennzahlObj({
        standort_tid,
        data,
        kennName: `Menge ${rowCopy.name}`,
        bereich: Kennzahl.BEREICH_SCOPE3,
        key: kennKey,
        field: 'menge',
        item: rowCopy,
        einheit: rowCopy.einheit
    });
    const co2Params: any = {
        standort_tid,
        data,
        kennName: `CO₂-Emission ${row_wasser.name}`,
        bereich: Kennzahl.BEREICH_SCOPE3,
        key: `${kennKey}_co2`,
        field: 'menge',
        item: rowCopy,
        einheit: 't',
        einheitOrig: rowCopy.einheit,
        faktor_co2: faktor.wert,
        faktor_co2_einheit: 't/m³',
        faktor_co2_quelle: rowCopy.quelle
    };
    setKennzahlObj(co2Params);
    // Gesamtemissionen SCOPE 3
    setKennzahlS3Co2Gesamt(co2Params, structure);
}
